import React from 'react';
import {
  SimpleDialog,
  Typography,
  styled,
  Checkbox,
  FormControlLabel,
} from '@nextiva/next-ui-components';
import ToggleRow from '../ToggleRow';

const dialogPaperStyle = {
  maxHeight: '90vh',
  height: 'auto',
  borderRadius: 8,
  padding: 0,
  position: 'fixed',
  top: '0%',
  left: '0%',
  overflow: 'auto',
  zIndex: 1300,
};

const DialogMessage = styled(Typography)`
  margin: 0px 0px 24px 0px;
`;
const CustomFormControlLabel = styled(FormControlLabel)`
  gap: 8px;
  align-items: center;
  margin-bottom: 24px;
`;

const PeoplePermissionsSection = ({
  toggles,
  onTogglesChange,
  dialog,
  onDialogContinue,
  onDialogCancel,
  dontShow,
  onDontShowChange,
  disabled = false,
}) => {
  const handleToggleTeams = ({ 'Manage Teams': checked }) => {
    if (!checked) {
      // Turning off Manage Teams doesn't require dialog
      onTogglesChange({ ...toggles, 'Manage Teams': false });
    } else if (toggles['Manage Users']) {
      onTogglesChange({ ...toggles, 'Manage Teams': true });
    } else {
      // Enabling Manage Teams requires enabling Manage Users
      onTogglesChange(
        {
          ...toggles,
          'Manage Teams': true,
          'Manage Users': true,
        },
        'enable',
      );
    }
  };

  const handleToggleUsers = ({ 'Manage Users': checked }) => {
    if (checked === false && toggles['Manage Teams']) {
      // Disabling Manage Users while Manage Teams is enabled requires dialog
      onTogglesChange(
        {
          ...toggles,
          'Manage Teams': false,
          'Manage Users': false,
        },
        'disable',
      );
    } else {
      onTogglesChange({ ...toggles, 'Manage Users': checked });
    }
  };
  const handleToggleRoles = ({ 'Manage Roles & Permissions': checked }) => {
    if (checked) {
      onTogglesChange({ ...toggles, 'Manage Roles & Permissions': true });
    } else {
      // Disabling Manage Roles & Permissions doesn't require dialog
      onTogglesChange({ ...toggles, 'Manage Roles & Permissions': false });
    }
  };

  return (
    <>
      <ToggleRow
        name="Manage Teams"
        value={!!toggles['Manage Teams']}
        onToggleRowChange={handleToggleTeams}
        disabled={disabled}
      />
      <ToggleRow
        name="Manage Users"
        value={!!toggles['Manage Users']}
        onToggleRowChange={handleToggleUsers}
        disabled={disabled}
      />
      <ToggleRow
        name="Manage Roles & Permissions"
        value={!!toggles['Manage Roles & Permissions']}
        onToggleRowChange={handleToggleRoles}
        disabled={disabled}
      />
      <SimpleDialog
        style={dialogPaperStyle}
        open={dialog.open}
        cancelButtonProps={{
          onClick: onDialogCancel,
          'data-testid': 'PlatformAdminUI-People-Dialog-CancelButton',
        }}
        cancelText="Cancel"
        confirmButtonProps={{
          onClick: onDialogContinue,
          'data-testid': 'PlatformAdminUI-People-Dialog-ContinueButton',
        }}
        confirmText="Continue"
        title={
          dialog.type === 'enable'
            ? 'Enable Manage Teams permission'
            : 'Disable Manage Teams permission'
        }
      >
        <DialogMessage>
          {dialog.type === 'enable' ? (
            <>
              Granting the Manage Teams permission will also enable the Manage
              Users permission.
              <br />
              This is required because team management relies on user management
              capabilities.
            </>
          ) : (
            <>
              Removing the Manage Users permission from this role will also
              remove Manage Teams, which depends on it.
              <br />
              If you continue, this role will no longer include either
              permission.
            </>
          )}
        </DialogMessage>
        <CustomFormControlLabel
          control={
            <Checkbox
              checked={!!dontShow}
              onChange={onDontShowChange}
              data-testid="PlatformAdminUI-People-Dialog-DontShowCheckbox"
            />
          }
          label="Don’t show me this again today"
        />
      </SimpleDialog>
    </>
  );
};

export default PeoplePermissionsSection;
